import Vector3 from '../math/Vector3';
import TRIANGLE_normal from '../faces/TRIANGLE_normal';

export default class CubeGeometry {
	positions: Array<Vector3>;
	normals: Array<Vector3>;
	faces: Array<TRIANGLE_normal>;

	constructor (dimension: number, offset: Vector3) {
		var x = offset.x;
		var y = offset.y;
		var z = offset.z;

		var halfDim = dimension / 2;
		var x0 = x - halfDim;
		var x1 = x + halfDim;
		var y0 = y - halfDim;
		var y1 = y + halfDim;
		var z0 = z - halfDim;
		var z1 = z + halfDim;

		this.positions = [
			new Vector3(x0, y0, z0),
			new Vector3(x0, y0, z1),
			new Vector3(x0, y1, z0),
			new Vector3(x0, y1, z1),
			new Vector3(x1, y0, z0),
			new Vector3(x1, y0, z1),
			new Vector3(x1, y1, z0),
			new Vector3(x1, y1, z1)
		];

		this.normals = [
			new Vector3(0, 0, -1),
			new Vector3(0, 0,  1),
			new Vector3(0, -1, 0),
			new Vector3(0,  1, 0),
			new Vector3(-1, 0, 0),
			new Vector3( 1, 0, 0)
		];

		this.faces = CubeGeometry.getFaces(0, 0);
		// this.faces = [
		// 	// cube side z0
		// 	new TRIANGLE_normal(0, 2, 4, 0, 0, 0),
		// 	new TRIANGLE_normal(6, 4, 2, 0, 0, 0),
		// 	// cube side z1
		// 	new TRIANGLE_normal(1, 5, 3, 1, 1, 1),
		// 	new TRIANGLE_normal(7, 3, 5, 1, 1, 1),
		// 	// cube side y0
		// 	new TRIANGLE_normal(0, 4, 1, 2, 2, 2),
		// 	new TRIANGLE_normal(5, 1, 4, 2, 2, 2),
		// 	// cube side y1
		// 	new TRIANGLE_normal(2, 3, 6, 3, 3, 3),
		// 	new TRIANGLE_normal(7, 6, 3, 3, 3, 3),
		// 	// cube side x0
		// 	new TRIANGLE_normal(0, 1, 2, 4, 4, 4),
		// 	new TRIANGLE_normal(3, 2, 1, 4, 4, 4),
		// 	// cube side x1
		// 	new TRIANGLE_normal(4, 6, 5, 5, 5, 5),
		// 	new TRIANGLE_normal(7, 5, 6, 5, 5, 5)
		// ];
	}

	static getFaces (positionOffset: number, normalOffset: number) {
		var p0 = positionOffset;
		var p1 = positionOffset + 1;
		var p2 = positionOffset + 2;
		var p3 = positionOffset + 3;
		var p4 = positionOffset + 4;
		var p5 = positionOffset + 5;
		var p6 = positionOffset + 6;
		var p7 = positionOffset + 7;

		var n0 = normalOffset;
		var n1 = normalOffset + 1;
		var n2 = normalOffset + 2;
		var n3 = normalOffset + 3;
		var n4 = normalOffset + 4;
		var n5 = normalOffset + 5;

		// Two faces per cube side
		// Defining triangle counter-clockwise
		return [
			// cube side z0
			new TRIANGLE_normal(p0, p2, p4, n0, n0, n0),
			new TRIANGLE_normal(p6, p4, p2, n0, n0, n0),
			// cube side z1
			new TRIANGLE_normal(p1, p5, p3, n1, n1, n1),
			new TRIANGLE_normal(p7, p3, p5, n1, n1, n1),
			// cube side y0
			new TRIANGLE_normal(p0, p4, p1, n2, n2, n2),
			new TRIANGLE_normal(p5, p1, p4, n2, n2, n2),
			// cube side y1
			new TRIANGLE_normal(p2, p3, p6, n3, n3, n3),
			new TRIANGLE_normal(p7, p6, p3, n3, n3, n3),
			// cube side x0
			new TRIANGLE_normal(p0, p1, p2, n4, n4, n4),
			new TRIANGLE_normal(p3, p2, p1, n4, n4, n4),
			// cube side x1
			new TRIANGLE_normal(p4, p6, p5, n5, n5, n5),
			new TRIANGLE_normal(p7, p5, p6, n5, n5, n5)
		];
	}

	// _getEdges () {
	// 	// Two edges per cube side
	// 	return [
	// 		// cube edges along z-axis
	// 		new Edge(0, 1),
	// 		new Edge(2, 3),
	// 		new Edge(4, 5),
	// 		new Edge(6, 7),
	// 		// cube edges along y-axis
	// 		new Edge(0, 2),
	// 		new Edge(1, 3),
	// 		new Edge(4, 6),
	// 		new Edge(5, 7),
	// 		// cube edges along x-axis
	// 		new Edge(0, 4),
	// 		new Edge(1, 5),
	// 		new Edge(2, 6),
	// 		new Edge(3, 7)
	// 	];
	// }
}
